import { MessageSquare, ThumbsUp, UserPlus } from "react-feather";
import { AboutDetailTypes } from "../../../Types/SocialAppType";

export const mutualFriendsData = [
    {
        id: 1,
        image: `2.png`,
        name: 'Bucky Barnes',
        email: 'winter@gmail.com',
        status: 'social-online'
    },
    {
        id: 2,
        image: `10.jpg`,
        name: 'Sarah Loren',
        email: 'barnes@gmail.com',
        status: 'social-busy'
    },
    {
        id: 3,
        image: `6.jpg`,
        name: 'Jason Borne',
        email: 'jasonb@gmail.com',
        status: 'social-offline'
    },
    {
        id: 4,
        image: `8.jpg`,
        name: 'Comeren Diaz',
        email: 'comere@gmail.com',
        status: 'social-offline'
    },
    {
        id: 5,
        image: `14.png`,
        name: 'Andew Jon',
        email: 'andrewj@gmail.com',
        status: 'social-online'
    },
    {
        id: 6,
        image: `4.jpg`,
        name: 'Johny Waston',
        email: 'johny@gmail.com',
        status: 'social-busy'
    },
    {
        id: 7,
        image: `3.png`,
        name: 'Johny William',
        email: 'johnyw@gmail.com',
        status: 'social-offline'
    },
    {
        id: 8,
        image: `2.png`,
        name: 'Bucky Barnes',
        email: 'winter@gmail.com',
        status: 'social-online'
    },
    {
        id: 9,
        image: `10.jpg`,
        name: 'Sarah Loren',
        email: 'barnes@gmail.com',
        status: 'social-busy'
    },
    {
        id: 10,
        image: `6.jpg`,
        name: 'Jason Borne',
        email: 'jasonb@gmail.com',
        status: 'social-offline'
    },
    {
        id: 11,
        image: `8.jpg`,
        name: 'Comeren Diaz',
        email: 'comere@gmail.com',
        status: 'social-offline'
    },
    {
        id: 12,
        image: `14.png`,
        name: 'Andew Jon',
        email: 'andrewj@gmail.com',
        status: 'social-online'
    },
    {
        id: 13,
        image: `4.jpg`,
        name: 'Johny Waston',
        email: 'johny@gmail.com',
        status: 'social-busy'
    },
    {
        id: 14,
        image: `3.png`,
        name: 'Johny William',
        email: 'johny@gmail.com',
        status: 'social-offline'
    }
];

export const activityFeedData = [
    {
        id: 1,
        image: `10.jpg`,
        name: 'Andew Jon',
        paragraph: `Commented on Shaun Park's`,
        time: '20 min Ago'
    },
    {
        id: 2,
        image: `3.jpg`,
        name: 'Johny Waston',
        paragraph: `Commented on Shaun Park's`,
        time: '1 hour Ago'
    },
    {
        id: 3,
        image: `5.jpg`,
        name: 'Comeren Diaz',
        paragraph: `Commented on Shaun Park's`,
        time: '1 days Ago'
    },
    {
        id: 4,
        image: `4.jpg`,
        name: 'Sarah Loren',
        paragraph: `Commented on Shaun Park's`,
        time: '2 days Ago'
    },
    {
        id: 5,
        image: `3.jpg`,
        name: 'Johny Waston',
        paragraph: `Commented on Shaun Park's`,
        time: '5 days Ago'
    },
    {
        id: 6,
        image: `5.jpg`,
        name: 'Comeren Diaz',
        paragraph: `Commented on Shaun Park's`,
        time: '6 days Ago'
    }
];

export const newUsersSocialData = [
    {
        id: 1,
        image: '1.png',
        paragraph: "The only way to do something in depth is to work hard. I've always thought of the T-shirt as the Alpha of the fashion alphabet. My breakfast is very important. Everything I do is a matter of heart, body and soul.",
        child: [
            {
                id: 1,
                divClass: 'your-msg',
                src: '1.jpg',
                name: 'Jason Borne',
                time: '1 Year Ago',
                paragraph: 'we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post',
            },
            {
                id: 2,
                divClass: 'other-msg',
                src: '2.png',
                name: 'Alexendra Dhadio',
                time: '1 Month Ago',
                paragraph: 'yes, really very awesome car i see the features of this car in the official website of #Mercedes-Benz and really impressed :-)',
            },
            {
                id: 3,
                divClass: 'other-msg',
                src: '3.png',
                name: 'Olivia Jon',
                time: '15 Days Ago',
                paragraph: 'i like lexus cars, lexus cars are most beautiful with the awesome features, but this car is really outstanding than lexus',
            },
            {
                id: 4,
                divClass: 'your-msg',
                src: '1.jpg',
                name: 'Issa Bell',
                time: '1 Year Ago',
                paragraph: 'we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post',
            },
        ]
    },
    {
        id: 2,
        image: '2.png',
        paragraph: "I've always thought of the T-shirt as the Alpha of the fashion alphabet. My breakfast is very important. Everything I do is a matter of heart, body and soul. The only way to do something in depth is to work hard.",
        child: [
            {
                id: 1,
                divClass: 'your-msg',
                src: '1.jpg',
                name: 'Jason Borne',
                time: '1 Year Ago',
                paragraph: 'we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post',
            },
            {
                id: 2,
                divClass: 'your-msg',
                src: '1.jpg',
                name: 'Issa Bell',
                time: '1 Year Ago',
                paragraph: 'we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post',
            },
        ]
    }
];

export const followCardData = [
    {
        id: 1,
        image: '2.png',
        name: 'Bucky Barnes'
    },
    {
        id: 2,
        image: '3.png',
        name: 'Sarah Loren'
    },
    {
        id: 3,
        image: '3.jpg',
        name: 'Jason Borne'
    },
    {
        id: 4,
        image: '10.jpg',
        name: 'Comeren Diaz'
    },
    {
        id: 5,
        image: '11.png',
        name: 'Andew Jon'
    },
];

export const knownPeopleData = [
    {
        id: 1,
        src: '2.png',
        name: 'Jason Borne'
    },
    {
        id: 2,
        src: '3.png',
        name: 'Anna Mull'
    },
    {
        id: 3,
        src: '3.jpg',
        name: 'Dion Cast'
    },
    {
        id: 4,
        src: '4.jpg',
        name: 'Karlene Lex'
    },
    {
        id: 5,
        src: '8.jpg',
        name: 'Vella Chism'
    },
    {
        id: 6,
        src: '10.jpg',
        name: 'Wai Schalk'
    },
    {
        id: 14,
        src: '14.png',
        name: 'Karlene Lex'
    },
];

export const aboutDetailsData: AboutDetailTypes[] = [
    {
        id: 1,
        title: 'Hobbies and Interests',
        child: [
            {
                id: 1,
                details: [
                    {
                        id: 1,
                        text: 'Hobbies',
                        paragraph: 'I like to ride the bike to work, swimming, and working out. I also like reading design magazines, go to museums, and binge watching a good tv show while it’s raining outside.',
                    },
                    {
                        id: 2,
                        text: 'Favourite Music Bands / Artists',
                        paragraph: 'Iron Maid, DC/AC, Megablow, The Ill, Kung Fighters, System of a Revenge.',
                    },
                ]
            },
            {
                id: 2,
                details: [
                    {
                        id: 1,
                        text: 'Favourite TV Shows',
                        paragraph: 'Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.',
                    },
                    {
                        id: 2,
                        text: 'Favourite Books',
                        paragraph: 'The Crime of the Century, Egiptian Mythology 101, The Scarred Wizard, Lord of the Wings, Amongst Gods, The Oracle, A Tale of Air and Water.',
                    },
                ]
            },
            {
                id: 3,
                details: [
                    {
                        id: 1,
                        text: 'Favourite Movies',
                        paragraph: 'Idiocratic, The Scarred Wizard and the Fire Crown, Crime Squad Ferrum Man.',
                    },
                    {
                        id: 2,
                        text: 'Favourite Writers',
                        paragraph: 'Martin T. Georgeston, Jhonathan R. Token, Ivana Rowle, Alexandr Platt, Marcus Roth.',
                    },
                ]
            },
            {
                id: 4,
                details: [
                    {
                        id: 1,
                        text: 'Favourite Games',
                        paragraph: 'The First of Us, Assassin’s Squad, Dark Assylum, NMAK16, Last Cause 4, Grand Snatch Auto.',
                    },
                    {
                        id: 2,
                        text: 'Other Interests',
                        paragraph: 'Swimming, Surfing, Scuba Diving, Anime, Photography, Tattoos, Street Art.',
                    },
                ]
            },

        ]

    },
    {
        id: 2,
        title: 'Education and Employement',
        child: [
            {
                id: 1,
                details: [
                    {
                        id: 1,
                        text: 'The New College of Design',
                        year: '2001 - 2006',
                        paragraph: 'Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.',
                    },
                    {
                        id: 2,
                        text: 'Digital Design Intern',
                        year: '2006 - 2023',
                        paragraph: 'Digital Design Intern for the “Multimedz” agency. Was in charge of the communication with the clients.',
                    },
                ]
            },
            {
                id: 2,
                details: [
                    {
                        id: 1,
                        text: 'Rembrandt Institute',
                        year: '2023',
                        paragraph: 'Five months Digital Illustration course. Professor: Leonardo Stagg.',
                    },
                    {
                        id: 2,
                        text: 'UI/UX Designer',
                        year: '2001 - 2006',
                        paragraph: 'Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.',
                    },
                ]
            },
            {
                id: 3,
                details: [
                    {
                        id: 1,
                        text: 'The Digital College',
                        year: '2023',
                        paragraph: '6 months intensive Motion Graphics course. After Effects and Premire. Professor: Donatello Urtle.',
                    },
                    {
                        id: 2,
                        text: 'The New College of Design',
                        year: '2023 - 2023',
                        paragraph: 'UI/UX Designer for the “Daydreams” agency.',
                    },
                ]
            }
        ]
    }
];

export const activityLogData = [
    {
        id: 1,
        title: 'Today',
        child: [
            {
                id: 1,
                icon: <ThumbsUp className="m-r-20" />,
                text: 'Comeren Diaz likes your photos.'
            },
            {
                id: 2,
                icon: <UserPlus className="m-r-20" />,
                text: 'Karlene Lex and Comeren Diaz now friends.'
            },
            {
                id: 3,
                icon: <MessageSquare className="m-r-20" />,
                text: 'Sarah Loren wrote on your timeline'
            },
            {
                id: 4,
                icon: <ThumbsUp className="m-r-20" />,
                text: "Johny Waston likes your post's"
            },
            {
                id: 5,
                icon: <UserPlus className="m-r-20" />,
                text: 'Andew Jon became friends with Comeren Diaz.'
            },
            {
                id: 6,
                icon: <UserPlus className="m-r-20" />,
                text: 'Johny Waston became friends with Bucky Barnes.'
            }
        ]
    },
    {
        id: 2,
        title: '25 December',
        child: [
            {
                id: 1,
                icon: <ThumbsUp className="m-r-20" />,
                text: 'Comeren Diaz likes your photos.'
            },
            {
                id: 2,
                icon: <ThumbsUp className="m-r-20" />,
                text: "Johny Waston likes your post's"
            },
            {
                id: 3,
                icon: <UserPlus className="m-r-20" />,
                text: 'Karlene Lex and Comeren Diaz now friends.'
            },
            {
                id: 4,
                icon: <UserPlus className="m-r-20" />,
                text: 'Johny Waston became friends with Bucky Barnes.'
            },
            {
                id: 5,
                icon: <MessageSquare className="m-r-20" />,
                text: 'Sarah Loren wrote on your timeline'
            },
            {
                id: 6,
                icon: <MessageSquare className="m-r-20" />,
                text: 'Comeren Diaz wrote on your timeline'
            },

        ]
    },
    {
        id: 3,
        title: '8 september',
        child: [
            {
                id: 1,
                icon: <ThumbsUp className="m-r-20" />,
                text: 'Comeren Diaz likes your photos.'
            },
            {
                id: 2,
                icon: <ThumbsUp className="m-r-20" />,
                text: "Johny Waston likes your post's"
            },
            {
                id: 3,
                icon: <UserPlus className="m-r-20" />,
                text: 'Karlene Lex and Comeren Diaz now friends.'
            },
            {
                id: 4,
                icon: <UserPlus className="m-r-20" />,
                text: 'Johny Waston became friends with Bucky Barnes.'
            },
            {
                id: 5,
                icon: <MessageSquare className="m-r-20" />,
                text: 'Sarah Loren wrote on your timeline'
            },
            {
                id: 6,
                icon: <UserPlus className="m-r-20" />,
                text: 'Andew Jon became friends with Comeren Diaz.'
            },
        ]
    },
    {
        id: 4,
        title: '6 June',
        child: [
            {
                id: 1,
                icon: <ThumbsUp className="m-r-20" />,
                text: 'Comeren Diaz likes your photos.'
            },
            {
                id: 2,
                icon: <UserPlus className="m-r-20" />,
                text: 'Karlene Lex and Comeren Diaz now friends.'
            },
            {
                id: 3,
                icon: <MessageSquare className="m-r-20" />,
                text: 'Sarah Loren wrote on your timeline'
            },
            {
                id: 4,
                icon: <ThumbsUp className="m-r-20" />,
                text: "Johny Waston likes your post's"
            },
            {
                id: 5,
                icon: <UserPlus className="m-r-20" />,
                text: 'Andew Jon became friends with Comeren Diaz.'
            },
            {
                id: 6,
                icon: <UserPlus className="m-r-20" />,
                text: 'Johny Waston became friends with Bucky Barnes.'
            }
        ]
    },
];

export const socialPhotosData = [
    {
        id: 1,
        image: '01.jpg',
        title: 'Johan Deo'
    },
    {
        id: 2,
        image: '02.jpg',
        title: 'Dev John'
    },
    {
        id: 3,
        image: '03.jpg',
        title: 'Johan Deo'
    },
    {
        id: 4,
        image: '04.jpg',
        title: 'Comeren Diaz'
    },
    {
        id: 5,
        image: '05.jpg',
        title: 'Andew Jon'
    },
    {
        id: 6,
        image: '011.jpg',
        title: 'Sarah Loren'
    },
    {
        id: 7,
        image: '010.jpg',
        title: 'Andew Jon'
    },
    {
        id: 8,
        image: '08.jpg',
        title: 'Bucky Barnes'
    },
];

export const socialCardLinkList = [
    {
        id: 1,
        link: "https://www.facebook.com/",
        icon: 'facebook'
    },
    {
        id: 2,
        link: "https://accounts.google.com/",
        icon: 'google-plus'
    },
    {
        id: 3,
        link: "https://twitter.com/",
        icon: 'twitter'
    },
    {
        id: 4,
        link: "https://www.instagram.com/",
        icon: 'instagram'
    },
    {
        id: 5,
        link: "https://rss.app/",
        icon: 'rss'
    },
]